<hub-sub-menu></hub-sub-menu>
<div *ngIf="!!hub && !!boiler;">
  <div *ngIf="editable" class="editable">
    <div class="boiler_details">
      <div class="editrow" *ngIf="!!fuels">
        <mat-form-field id="fuel_type_id">
          <mat-select class="form-control" id="fuel_type_id" required placeholder="fuel type"
            [(ngModel)]="boiler.fuel_type_id" name="fuel_type_id">
            <mat-option *ngFor="let fuel of fuels" [value]="fuel.fuel_type_id">{{fuel.fuel_type_description}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field id="energy_output" class="with_left_margin number">
          <input matInput [(ngModel)]="boiler.energy_output" type="number" placeholder="kWh output" />
        </mat-form-field>
        <mat-form-field id="fuel_rate" class="with_left_margin number">
          <input matInput [(ngModel)]="boiler.fuel_rate" type="number" placeholder="fuel rate" />
        </mat-form-field>
        <mat-form-field id="tank_capacity" class="with_left_margin number">
          <input matInput [(ngModel)]="boiler.tank_capacity" type="number" placeholder="tank capacity" />
        </mat-form-field>
      </div>
    </div>
    <div class="editrow">
      <mat-form-field id="manufacturer" class="left">
        <input matInput [(ngModel)]="boiler.manufacturer" type="string" placeholder="manufacturer" />
      </mat-form-field>
      <mat-form-field id="model" class="with_left_margin">
        <input matInput [(ngModel)]="boiler.model" type="string" placeholder="model" />
      </mat-form-field>
    </div>
    <div class="editrow">
      <mat-form-field id="last_measured_date" class="date">
        <input matInput [(ngModel)]="boiler.last_measured_date" type="string" placeholder="last measured on" />
      </mat-form-field>
      <mat-form-field id="last_measured_level" class="with_left_margin number">
        <input matInput [(ngModel)]="boiler.last_measured_level" type="number" placeholder="last measured level" />
      </mat-form-field>
      <mat-form-field id="aga_flow_rate" class="with_left_margin number">
        <input matInput [(ngModel)]="boiler.aga_flow_rate" type="number" placeholder="Aga Flow Rate (L/hr)" />
      </mat-form-field>
      <div class="panel">
        <button mat-raised-button (click)="cancel()"> Cancel </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="!isValid()"> Save </button>
      </div>
    </div>
    <div class="editrow">
      <p class="error" *ngFor="let error of errorMessages">{{error}}</p>
    </div>
  </div>
  <div *ngIf="!editable" class="boiler_details">
    <div class="displayrow">
      <label class="left"> Fuel: </label>{{fuel_type_description}}
      <label class="with_left_margin"> Energy: </label><span class="number">{{boiler.energy_output}} kWh</span>
      <label class="with_left_margin"> Fuel Rate: </label><span class="number">{{boiler.fuel_rate}} kg/hr</span>
      <label class="with_left_margin"> Tank Capacity: </label><span class="number">{{boiler.tank_capacity}} l</span>
      <grafana-oil-link [inHub]="hub"></grafana-oil-link>
      <div class="panel">
        <button mat-raised-button (click)="edit()"> Edit </button>
      </div>
    </div>
    <div class="displayrow">
      <label class="left"> Measured On: </label><span class="timestamp">{{boiler.last_measured_date | godate}}</span>
      <label class="with_left_margin"> Level: </label><span class="number">{{boiler.last_measured_level}} litres</span>
      <label class="with_left_margin"> Aga Flow Rate: </label><span class="number">{{boiler.aga_flow_rate}} L/day</span>
    </div>
  </div>
</div>
<div *ngIf="!!errorMessage" class="error">{{errorMessage}}</div>
<div id="fills">
  <h2>Fuel Fills</h2>
  <ul class="fills">
    <li>
      <span class="timestamp center" >Date</span>
      <span class="number center">Amount</span>
      <span class="number center">Full?</span>
      <span class="actions">
        <mat-icon class="md-48" color="primary" aria-label="Add a new row" (click)="addFuelFill()">add_outline</mat-icon>
      </span>
    </li>
    <li *ngIf="newFill">
      <fuel-fill-edit
          [inFill]="newFill"
          (fillSaved)="onFillSaved($event)"></fuel-fill-edit>
    </li>
    <li *ngFor="let fill of fills">
      <span class="timestamp center" > {{fill.fill_timestamp | godate}} </span>
      <span class="number"> {{fill.fill_amount}} </span>
      <span class="number center"> {{fill.tank_filled | boolean}} </span>
      <span class="actions">
        <mat-icon class="md-48" color="warn" aria-label="Delete this row" (click)="deleteFuelFill(fill)">clear</mat-icon>
      </span>
    </li>
  </ul>
</div>
